import DescriptionIcon from '@mui/icons-material/DescriptionOutlined';
import EmailIcon from '@mui/icons-material/EmailOutlined';
import AssignmentIcon from '@mui/icons-material/AssignmentOutlined';
import GavelIcon from '@mui/icons-material/GavelOutlined';

export const DRAFT_TEMPLATES = [
  { key: 'contestacion', label: 'Escrito de contestación', description: 'Con fundamentos y estructura formal', icon: DescriptionIcon },
  { key: 'comunicacion_aseguradora', label: 'Comunicación a aseguradora', description: 'Reclamación de indemnización', icon: EmailIcon },
  { key: 'hoja_encargo', label: 'Hoja de encargo', description: 'Presupuesto y condiciones', icon: AssignmentIcon },
  { key: 'requerimiento_masc', label: 'Requerimiento MASC', description: 'Medio adecuado de solución de controversias', icon: GavelIcon },
];